import PLAYTECHLIVEActions from './PLAYTECHLIVEActions'

export default class PLAYTECHTABLEActions extends PLAYTECHLIVEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'PLAYTECH-TABLE-001',
      platform: 'PLAYTECH',
    }

    this.gameName = 'Blackjack LINK'

    this.constantGameInfo = {
      betDetails: {
        tableCoverage: 0,
        betType: 'MAIN_BET',
      },
    }

    // roundId: gpas_pa6vq1fPUCMKrVSu-07s#d8171c80, gpas_LOt2JAyXVNoW7NpCXX7D#d8171c80
    this.roundIdPrefix = 'gpas'
    this.roundIdSufix = 'd8171c80'
    // platformTxId: 116314030

    // Multi Bets
    this.constantTxnData_multiBets = this.constantTxnData
    this.gameName_multiBets = this.gameName
    this.constantGameInfo_multiBets = this.constantGameInfo
    this.roundIdSufix_multiBets = this.roundIdSufix
  }
}
